package kz.dentalcrm.app.di

import kz.dentalcrm.app.core.storage.Settings
import kz.dentalcrm.app.core.storage.Storage
import org.koin.dsl.module

fun getStorage() = module {
    factory<Storage> { Storage(
        settings = Settings()
    ) }
}